import { Path, Rect } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function OrdersIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Rect x="5" y="3" width="14" height="18" rx="2" />
      <Path d="M9 8h6M9 12h6M9 16h4" />
    </LineIcon>
  );
}
